<section class="" [ngClass]="config.cssClass">
  <!-- {{ config.label }}
  <p class="" [innerHTML]="config['intro']"></p> -->

  @if (config['address']) {
    <div>
      <p class="type-body-sm mb-2">
        {{ 'form-verbonden-adres-intro-tekst' | fromDictionary }}
        <a [routerLink]="['/account']">{{ 'form-verbonden-adres-account-link-tekst' | fromDictionary }}</a>
      </p>
      <app-address-card class="d-block mb-3" [address]="config['address']" [hideActions]="true"></app-address-card>
      <!-- <div>
      <a class="button button-link" [routerLink]="['/account/add-address']" [queryParams]="{ returnUrl: '/account/bewerken' }">
        <app-icon anchor="icon-plus"></app-icon>
        <span>Adres toevoegen</span>
      </a>
      <a class="button button-link" [routerLink]="['/account/add-address']" [queryParams]="{ returnUrl: '/account/bewerken' }">
        <app-icon anchor="icon-edit"></app-icon>
        <span>Kies adres</span>
      </a>
    </div> -->
  </div>
}

@if (!config['address']) {
  <app-alert class="d-block mb-3 text-center" [status]="'type--info'">
    <div class="px-3 py-4">
      <h2 class="h4 text-secondary mt-0">{{ 'adressen-overzicht-leeg-titel' | fromDictionary }}</h2>
      <p class="mb-4 text-dark">{{ 'form-verbonden-adres-onbekend-btw' | fromDictionary }}</p>
      <a [routerLink]="['/account/add-address']" [queryParams]="{ returnUrl: '/account/bewerken' }" class="button button--light button--sm">
        <span>{{ 'form-verbonden-adres-toevoegen-knoptekst' | fromDictionary }}</span>
      </a>
    </div>
  </app-alert>
}
</section>
